import React from 'react';
import { motion } from 'framer-motion';
import { Factory, Sun, ShieldCheck, PaintBucket } from 'lucide-react';

// 1. Smoking Factory (Amianto/Coperture)
export const SmokingFactory = ({ className }) => {
    return (
        <div className={`relative ${className} flex items-center justify-center`}>
            {/* The Icon */}
            <Factory strokeWidth={1} className="w-full h-full relative z-10" />

            {/* Smoke Particles */}
            <div className="absolute -top-2 left-2 z-0">
                {[...Array(3)].map((_, i) => (
                    <motion.div
                        key={i}
                        initial={{ opacity: 0, y: 0, scale: 0.5 }}
                        animate={{
                            opacity: [0, 0.5, 0],
                            y: -20,
                            scale: [0.5, 1, 1.5],
                            x: [0, (i % 2 === 0 ? 5 : -5), 0] // Wiggle
                        }}
                        transition={{
                            duration: 2,
                            repeat: Infinity,
                            delay: i * 0.6,
                            ease: "easeInOut"
                        }}
                        className="absolute bottom-0 w-2 h-2 bg-gray-400/50 rounded-full blur-[1px]"
                    />
                ))}
            </div>
        </div>
    );
};

// 2. Rotating Sun (Fotovoltaico)
export const RotatingSun = ({ className }) => {
    return (
        <motion.div
            className={className}
            animate={{ rotate: 360 }}
            transition={{ duration: 10, repeat: Infinity, ease: "linear" }}
        >
            <Sun strokeWidth={1} className="w-full h-full text-yellow-100" />
        </motion.div>
    );
};

// 3. Pulsing Shield (Sicurezza)
export const PulsingShield = ({ className }) => {
    return (
        <div className={`relative ${className} flex items-center justify-center`}>
            <ShieldCheck strokeWidth={1} className="w-full h-full relative z-10" />
            <motion.div
                className="absolute inset-0 bg-blue-500/40 rounded-full blur-md z-0"
                animate={{ scale: [1, 1.3, 1], opacity: [0.3, 0.7, 0.3] }}
                transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
            />
        </div>
    );
};

// 4. Tilting Paint Bucket (Ristrutturazione)
export const TiltingBucket = ({ className }) => {
    return (
        <motion.div
            className={className}
            whileInView={{ rotate: [0, -15, 0] }}
            transition={{ duration: 2, repeat: Infinity, repeatDelay: 1, ease: "easeInOut" }}
        >
            <PaintBucket strokeWidth={1} className="w-full h-full" />
        </motion.div>
    );
};
